export class CleoConversation {
  public id: number | null;
  public user_id: number | null;
  public reference: string | null;
  public title: string | null;
  public mood: 'friendly' | 'professional' | null;
  public total_cost: number | null;
  public flagged_at: Date | null;
  public flagged_by_user_id: number | null;
  public flag_reason: string | null;
  public created_at?: Date | null;
  constructor(data: CleoConversationData | void) {
    if (data === undefined) {
      this.id = null;
      this.user_id = null;
      this.reference = null;
      this.title = null;
      this.mood = null;
      this.total_cost = null;
      this.flagged_at = null;
      this.flagged_by_user_id = null;
      this.flag_reason = null;
    } else {
      this.id = data.id;
      this.user_id = data.user_id;
      this.reference = data.reference;
      this.title = data.title;
      this.mood = data.mood ?? null;
      this.total_cost = data.total_cost !== undefined && data.total_cost !== null
        ? Number(data.total_cost)
        : null;
      this.flagged_at = data.flagged_at ? new Date(data.flagged_at) : null;
      this.flagged_by_user_id = data.flagged_by_user_id ?? null;
      this.flag_reason = data.flag_reason ?? null;
      this.created_at = data.created_at ? new Date(data.created_at) : null;
    }
  }
}

export type CleoConversationData = {
  id: number | null;
  user_id: number | null;
  reference: string | null;
  title: string | null;
  mood: 'friendly' | 'professional' | null;
  total_cost: number | null;
  flagged_at: string | null;
  flagged_by_user_id: number | null;
  flag_reason: string | null;
  created_at: string | null;
};
